// Dependencies
import React from 'react';

// import { EVENT_TYPE, FORM_NAME } from '../../../../../lib/analytics-constants';
import { RentVsBuyInput } from '../../../../../lib/utils';
import { LEGACY_FIELD_NAMES } from '../../../analytics-constants';
import DownPaymentPercentInput from '../down-payment-percent';

const CONTROL_PANEL = 'controlPanel';

const analyticsPayload = {
  enabled: true,
  payload: {
    legacy: {
      formName: CONTROL_PANEL,
      fieldName: LEGACY_FIELD_NAMES.DOWN_PAYMENT_PERCENT,
    },
    // bedrock: {
    //   eventType: EVENT_TYPE.MORTGAGE_DOWN_PAYMENT_PERCENT_UPDATED,
    //   form_name: FORM_NAME.RENT_VS_BUY_CALCULATOR,
    //   was_prefilled: true,
    //   page_number: null,
    //   total_pages: null,
    // },
  },
};
const DownPaymentPercentInputWithAnalytics: React.FC<RentVsBuyInput> = ({
  className,
  fullWidth,
}) => {
  return (
    <DownPaymentPercentInput
      analytics={analyticsPayload}
      className={className}
      fullWidth={fullWidth}
    />
  );
};

export default DownPaymentPercentInputWithAnalytics;
